import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  CardMedia,
  Box, Select, MenuItem, FormControl,
  Typography,
  IconButton,
  Button,
  Modal,
  Popover, Autocomplete, TextField
} from "@mui/material";
import shared from "../../assets/landing_page/new/Coming Soon.svg";
import mytask from "../../assets/landing_page/Images/My Tasks.svg";
import health from "../../assets/landing_page/Images/Health Report.svg";
import project from "../../assets/landing_page/Images/Project Report.svg";
import http from "../../utils/http-common";
import { useNavigate, useLocation } from "react-router-dom";
function Reports(props) {

  // First, update the initial state to include both id and name
  const [planList, setPlanList] = useState({ id: "", name: "" });
  const [emptyUser, setEmptyUser] = useState(false);

  const [planListData, setPlanListData] = useState([]);


  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      const response = await http.get("master_service/myplan/details");
      if (response.data?.data) {
        const plans = response.data.data.map(plan => ({
          label: plan.plan_name,
          value: plan.plan_id
        }));
        setPlanListData(plans);
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (path) => {
    if (!planList) return;
    navigate(path, { state: { selectedPlanId: planList } });
  };


  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleOpen = (event) => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };


  useEffect(() => {
    getPlan();
  }, []);
  const [planData, setPlanData] = useState([]);
  const getPlan = async () => {
    try {
      const response = await http.get(
        "/master_service/get_all/plan_master/records"
      );

      if (response.status === 200) {
        if (response.data.length === 0) {
          setEmptyUser(true);
        }
        setPlanData(response.data);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  return (
    <div style={{ height: "100vh" }}>
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "2px 0",
          }}>
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "20px",
              fontWeight: 600,
              lineHeight: "21px",
              textAlign: "left",
            }}>
            Report
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "2px 0",
            marginTop: 13
          }}>
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "20px",
              fontWeight: 600,
              lineHeight: "21px",
              textAlign: "center",
              marginBottom: "5px"
            }}>
            Choose a Report
          </Typography>

        </Box>
        <Box 
  sx={{ 
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center", 
    marginBottom: "5px", 
    width: "100%"  // Ensure full width for proper centering
  }}
> 
  <FormControl sx={{ width: "780px", display: "flex" }}>
    <Autocomplete
      value={planListData.find(plan => plan.value === planList.id) || null}
      onChange={(event, newValue) => {
        if (newValue) {
          setPlanList({ id: newValue.value, name: newValue.label });
        } else {
          setPlanList({ id: "", name: "" });
        }
      }}
      options={planListData}
      getOptionLabel={(option) => option.label || ""}
      isOptionEqualToValue={(option, value) => 
        option.value === (value?.value || value?.id)
      }
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Select Plan"
          sx={{
            width: "100%", // Ensure it takes full width of FormControl
            backgroundColor: "white",
            "& .MuiOutlinedInput-root": {
              height: "35px", // Increased height slightly for better alignment
              fontSize: "12px",
              fontFamily: "Inter, sans-serif",
              fontWeight: 500,
              "& fieldset": {
                borderColor: "lightgray",
              },
              "&:hover fieldset": {
                borderColor: "lightgray",
              },
              "&.Mui-focused fieldset": {
                borderColor: "lightgray",
              },
            },
          }}
        />
      )}
    />
  </FormControl>
</Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1.3,
            //paddingRight: "13px",
            paddingLeft: "4px",
          }}
        >
          {[
            { image: mytask, title: "My Tasks", subtitle: "View all your tasks at one place", path: "" },
            { image: health, title: "Health Report", subtitle: "Check health report for the plans", path: "/home/healthreport" },
            { image: project, title: "Project Report", subtitle: "View all the project reports in one place", path: "" },
          ].map((card, index) => (
            <Card
              key={index}
              variant="outlined"
              onClick={() => handleClick(card.path)}
              sx={{
                width: 238,
                height: 220, // Fixed height for all cards
                margin: "10px", // Spacing between cards
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
            >
              <CardContent sx={{ px: 1, py: 2.5 }}>
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    height: 110,
                    "&:hover": {
                      color: "#0000001A",
                    },
                  }}
                >
                  <CardMedia
                    component="img"
                    image={card.image}
                    alt={card.title}
                    sx={{
                      height: "100%",
                      width: "100%",
                      objectFit: "contain",
                      display: "block",
                      margin: "auto",
                      backgroundColor: "#FFF",
                      transition: "background-color 0.3s ease",
                    }}
                  />
                  {(card.title === "My Tasks" || card.title === "Project Report") && (<CardMedia
                    component='img'
                    image={shared}
                    sx={{
                      position: "absolute",
                      top: 5,
                      right: -12,
                      width: 100,
                      height: 24,

                    }}
                  />)}
                </Box>
                <Box
                  sx={{
                    borderBottom: "1px solid #ccc",
                    backgroundColor: "#E5EEFB66",
                    marginTop: "10px",
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                    marginTop: "10px",
                    backgroundColor: "transparent",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontSize: "12px",
                      fontWeight: 700,
                      lineHeight: "16px",
                      textAlign: "left",
                      color: "black",
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                    }}
                  >
                    {card.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontSize: "10px",
                      fontWeight: 500,
                      lineHeight: "16px",
                      textAlign: "left",
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                    }}
                  >
                    {card.subtitle}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          ))}
        </Box>
      </>
    </div>
  );
}

export default Reports;
